import Cookies from 'js-cookie';

import { APP, ZOLL_ONLINE } from '@/constants';
import { container } from '@/container';
import { Environment } from '@/services/Environment';
import { RouterGuard } from '@/services/router/types';
import { pathJoin } from '@/utils/pathJoin';

/**
 * Handle logout redirect to ZO (which actually performs the logout).
 */
export const logoutGuard: RouterGuard = async function logoutGuard(to, from, next) {
  if (to.name === 'logout' || to.name === 'portal-logout') {
    const environment = await container.getAsync(Environment);
    Cookies.remove(APP.JWT_COOKIE_NAME);
    window.location.replace(pathJoin(environment.zoBaseUrl, ZOLL_ONLINE.LOGOUT_PATH));
    next();
  }
  else {
    next();
  }
};
